import { render } from "./footer.vue?vue&type=template&id=767203c7&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=767203c7&lang=less&scoped=true"
import "./footer.vue?vue&type=style&index=1&id=767203c7&lang=less&scoped=true"

import exportComponent from "E:\\project\\zjam-ctid\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767203c7"]])

export default __exports__